module.exports = __webpack_public_path__ + "img/spinner.150e15e4.svg";